/**
 * Decodes a JWT payload without verifying the signature.
 */
export function decodeJwt(token) {
    if (typeof token !== 'string') {
        throw new Error('Token must be a string');
    }
    var parts = token.split('.');
    if (parts.length !== 3) {
        throw new Error('Invalid token structure');
    }
    var payload = parts[1];
    if (!payload) {
        throw new Error('Invalid token payload');
    }
    // Handle URL-safe base64 by replacing characters
    var decodedPayload = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return decodedPayload;
}
/**
 * Validates if a string has the basic structure of a JWT and is NOT expired.
 */
export function isValidJwt(token) {
    try {
        var payload = decodeJwt(token);
        if (payload.exp) {
            // Safety margin of 10 seconds
            return payload.exp * 1000 > Date.now() + 10000;
        }
        return true;
    }
    catch (_a) {
        return false;
    }
}
